export const URL = "https://ndl1.education.gov.in/apis";